/*
* Created on Jan 25, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect, useState, useCallback, useRef} from 'react';
import ModalComponent from "../common/ModalComonent/ModalComponent";
import ic_search_svg from "../../static/img/utils/ic-search.svg";
import ic_arrow_drop_down from "../../static/img/utils/ic-arrow-drop-down.svg";
import ic_info_inline_svg from "../../static/img/utils/ic-info-inline.svg";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {useOrganization} from "../../context/OrganizationContext";
import useToggle from "../../hook/ToggleHook";
import _ from 'lodash';
import TextInputComponent from "../common/Form/TextInputComponent";
import {LENGTH_FORMAT, GROUP_DESCRIPTION_FORMAT} from "../../service/common";
import{useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import  {useRegion} from "../../context/RegionContext";
import {useQueryClient} from "@tanstack/react-query";
import {invalidateAccessGrant} from "../../service/accessGrantSync";


const GroupEditModalComponent = ({openModal, closeModal, group_data, doRefresh}) => {
    const {t} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const queryClient = useQueryClient();
    const [open, node] = useToggle();
    const current_organization = useOrganization();
    const {getCurrentOrg} = current_organization;
    const organization = getCurrentOrg();
    const [groupQueryFilter, setGroupQueryFilter] = useState();
    const {url} = useRegion();
    const modal = useRef();

    let initial_values = {
        group_name: {value:group_data.name, error: null, required: true},
        description: {value:group_data.description, error: null, required: false},
    };
    const [input, setInput] = useState(initial_values);
    const [userList, setUserList]= useState([]);
    const [userListType, setUserListType] = useState('Invited');
    const [checkAll, setCheckAll] = useState(false);
    const uninvited_list = useCallback(()=>{
        const result = _.differenceWith(
            organization.users || [],
            group_data.users || [],
            ({id:ouid, email:oemail, qid:oqid}, {id:guid, email:gemail}) => !!((ouid && guid) && ouid===guid) || ((oemail && gemail) ? oemail===gemail : false) || ((oqid && gemail) ? oqid===gemail : false));
        return result.map(u=>{u.checked=false; return u;})
    }, [group_data, organization]);

    const toggle_check_all = (e) => {
        if (e.target.checked) {
            setUserList((prev)=>{
                return prev.map(u=>{return {...u, checked: true}})
            });
            setCheckAll(true);
        }
        else {
            setUserList((prev)=>{
                return prev.map(u=>{return {...u, checked: false}})
            });
            setCheckAll(false);
        }
    }

    const onSubmit = async () => {
        console.log('Do submit')
        const data = {
            name: input.group_name.value,
            description: input.description.value
        }

        try {
            await OrganizationAPI.put(`organization/${organization.organization_id}/group/${group_data.organization_group_id}`, null, data);
        } catch (e) {
            modal.current.alert(true, 'error', e.response.data.code, e.response.data.message);
            return;
        }

        const users_to_remove = userList.filter(u=>!u.checked).filter(u=>{
            let match = false;
            for (let gu of group_data.users) {
                match = gu.id === u.id
                if (match) return match;
            }
            return match;
        }).map(u=>u.email).filter(u=>u!==undefined);
        console.log(users_to_remove);

        const users_to_add = userList.filter(u=>u.checked).filter(u=>{
            let match = false;
            for (let uu of uninvited_list()) {
                match = uu.id === u.id
                if (match) return match;
            }
            return match;
        }).map(u=>u.email).filter(u=>u!==undefined);
        console.log(users_to_add);

        if (users_to_remove) {
            await OrganizationAPI.delete(
            `organization/${organization.organization_id}/group/${group_data.organization_group_id}/user`, null,
            {emails: users_to_remove});
            // after success update the Group component will refresh thus modal will disappear so no need to update list
            // setUserList((prevUserList)=>{return prevUserList.filter(u=> u.checked)});
        }
        if (users_to_add) {
            await OrganizationAPI.post(
            `organization/${organization.organization_id}/group/${group_data.organization_group_id}/user`, null,
            {emails: users_to_add});
            // after success update the Group component will refresh thus modal will disappear so no need to update list
            // setUserList((prevUserList)=>{return prevUserList.filter(u=> !u.checked)});
        }
        modal.current.alert(false, null, 0, null, 1);
        invalidateAccessGrant(queryClient, organization.organization_id);
        queryClient.invalidateQueries({queryKey: [`organization/${organization.organization_id}/group`], refetchType: 'all'});
        doRefresh((prevVal)=>prevVal+1);
        closeModal();
    }

    const toggleUserList = (list_type) => {
        setUserListType(list_type);
        if (list_type === 'Uninvite') {
            setUserList(uninvited_list);
        }
        else {
            setUserList(()=>{
                return group_data.users.map(u=>({...u, checked: true}))
            });
            // setUserList(group_data.users);
        }
    }

    const toggle_user_remove_list = (user) => {
        setUserList((prevUserList)=>{
            return prevUserList.map(u=>{
                if (u?.email===user?.email) {
                    return {...u, checked: !u.checked}
                }
                return u
            });
        });
    }

    const onCheckBoxListChanged = () => {
        const test = userList.filter(u=>u.checked).length;
        const isFull = test === userList.length && userList.length > 0;
        setCheckAll(isFull);
    }

    const get_status = (user_status) => {
        const status = user_status;
        switch (status) {
            case 'active':
                return ['Activate', 'status-color-green'];
            case 'pending':
                return ['Invited', 'status-color-royal-blue'];
            case 'suspend':
                return ['Suspended', 'status-color-red'];
            default: //case '' || 'inactivate' || null || undefined:
                return ['QID not activated', 'status-color-purple'];
        }
    }

    useEffect(()=>{
        setInput(()=> {
            return({...input, ...initial_values})
        });
        // setUserList(()=>{
        //     return group_data.users.map(u=>({...u, checked: true}))
        // });
        setUserList(()=>{
            return group_data.users.map(u=>({...u, checked: true})).concat(uninvited_list());
        })
    }, [group_data]);

    useEffect(()=>{
        if (openModal === false) {
            setInput(()=> {
                return({...input, ...initial_values})
            });
        }
        setUserList(()=>{
            return group_data.users.map(u=>({...u, checked: true})).concat(uninvited_list());
        })

        return () => {
            setGroupQueryFilter("");
        }
    }, [openModal]);

    useEffect(()=>{
        onCheckBoxListChanged();
    }, [userList]);



    return (
        // <>
            <ModalComponent isOpen={openModal} onClose={closeModal} onSubmit={onSubmit} title={t('@Edit group@')} input={input} okText={t('@Apply@')} ref={modal}>
                <div className="dialog-content">
                    <form>
                        <TextInputComponent label={t('@Group name@')} field_name={'group_name'} input={input} setInput={setInput} place_holder={t('@Please input group name@')} format={LENGTH_FORMAT(50)}/>
                        <TextInputComponent label={t('@Group description@')} field_name={'description'} input={input} setInput={setInput} place_holder={t('@Please input group description@')} format={GROUP_DESCRIPTION_FORMAT(0, 50)}/>
                    </form>
                    <div className="dialog-content-divide !mt-32 !mb-8"/>
                    <div className="dialog-content-header !mt-16 !mb-24">{t('@Members@')}</div>
                    <div className="toolbar justify-content-end">
                        {/* <!-- 加入 class: active 顯示搜尋框 -->*/}
                        <div className="comp-search">
                            <img src={ic_search_svg} alt="" />
                            <div className="comp-input"><input type="text" placeholder="" onChange={e=>setGroupQueryFilter(e.target.value)}/></div>
                        </div>
                    </div>
                    {/* <!-- 群組列表 -->*/}
                    <div className="flexbox-table">
                        <div className="flexbox-thead">
                            <div className="thead-cell select-cell">
                                {/* <!-- 非全選的話 comp-checkbox 請加上 class： indeterminate -->*/}
                                <div className="comp-checkbox no-label">
                                    <input type="checkbox" id="cb-all" checked={checkAll} onChange={(e)=>toggle_check_all(e)}/>
                                    <label htmlFor="cb-all" className="comp-label"> </label>
                                </div>
                            </div>
                            <div className="thead-cell !w-80">
                                <div className="sort sort-disabled">
                                    <span className="sort-label">{t('@QID (Email)@')}</span>
                                    <span className="sort-arrow"><img src={ic_arrow_drop_down} alt=""/></span>
                                </div>
                            </div>
                            <div className="thead-cell !w-20">
                                <div className="sort sort-disabled">
                                    <span className="sort-label">{t('@Account status@')}</span>
                                    <span className="sort-arrow"><img
                                        src={ic_arrow_drop_down} alt=""/></span>
                                </div>
                            </div>
                        </div>
                        <OverlayScrollbarsComponent
                            className="flexbox-tbody overlay-scroll os-host-flexbox">
                            {userList &&
                                userList.filter(
                                    g=>g.display_name?.match(new RegExp(groupQueryFilter, 'i')) ||
                                        g.email?.match(new RegExp(groupQueryFilter, 'i'))  ||
                                        g.qid?.match(new RegExp(groupQueryFilter, 'i'))).map((user, index)=>{
                                return(
                                    <div className="flexbox-trow" key={index}>
                                        <div className="tbody-cell select-cell">
                                            <div className="comp-checkbox no-label">
                                                <input type="checkbox" id={`cb-${index}`} checked={user.checked}
                                                       onChange={async ()=>{
                                                           await toggle_user_remove_list(user)
                                                       }}
                                                />
                                                <label htmlFor={`cb-${index}`} className="comp-label"> </label>
                                            </div>
                                        </div>
                                        <div className="tbody-cell !w-80">
                                            <div className="admin-info">
                                                <div className="account-img">
                                                    <div className={`avatar ${user.avatars ? '' : 'no-avatar'}`}>
                                                        {!user.avatars && <span>{user.display_name != undefined ? user.display_name?.[0] : user.qid?.[0] || user.email?.[0]}</span>}
                                                        {user.avatars && <img src={`${url.get_acc_url()}/avatar/${user.id}/s`} alt=""/>}
                                                    </div>
                                                </div>
                                                <div className="account-info">
                                                    <div className="name">{user.display_name}</div>
                                                    <div className="mail">{user.email || user.qid}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tbody-cell !w-20">
                                            <div
                                                className={`status-tag ${get_status(user.status)?.[1]} no-border !pl-0 !pr-0 disable-event`}>
                                                <span className="label">{t(`@${get_status(user.status)?.[0]}@`)}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </OverlayScrollbarsComponent>
                    </div>
                    {/* <!-- 說明 -->*/}
                    <div className="text-wrap info-hint !mt-10 color-indigo">
                    <span className="ic-info-inline"><img src={ic_info_inline_svg} alt=""/></span>
                        {
                            userListType==='Invited' ?
                                <span>{t('@Uncheck the box next to a member and remove people from this group.@')}</span> :
                                <span>{t('@Check the box next to a member and invite people to this group.@')}</span>
                            // <span>{t('@Check the box next to a member and remove people from this group.@')}</span>
                        }
                    </div>
                </div>
            </ModalComponent>
        // </>
    );
};

export default GroupEditModalComponent;